import { ReportTheme } from '../other/report-theme.enum';
import { MobizSettingsValue } from './mobiz-settings-value.do';


export class ReportUserSettings extends MobizSettingsValue {
  ShowZeroRows: boolean = true;
  Theme: ReportTheme = ReportTheme.Light;
}
